export class Hero {
    public LegendaryHeroId: number = 0;
    public UserName: string = "";
    public Name: string = "";

    public Marvel: boolean = false;
    public Encounters: boolean = false;
    public Ally: boolean = false;
    public Expansion: string = "";

    public StrengthHero: boolean = false;
    public TechHero: boolean = false;
    public InstinctHero: boolean = false;
    public CovertHero: boolean = false;
    public RangedHero: boolean = false;

    public Team: string = "";
    public TeamShortName: string = "";
    public TeamIcon: string = "";

    public Sex: string = "";
    public Female: boolean = false;
    public Male: boolean = false;
    public Other: boolean = false;
    public Ripley: boolean = false;
    public Hulk: boolean = false;
    public Wolverine: boolean = false;
    public DisplayClass: string = "";
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/models/hero.ts